import { createEffect, sample } from 'effector';
import $$auth from 'models/auth';

import ZendeskHelpService from 'services/ZendeskHelpService';

import { type CurrentParticipant } from 'types/zod/current-participant';

sample({
    source: $$auth.$currentParticipant,
    filter: (user) => !user,
    target: createEffect(() => {
        ZendeskHelpService.clear();
    }),
});

sample({
    source: $$auth.$currentParticipant,
    filter: Boolean,
    target: createEffect((user: CurrentParticipant): void => {
        ZendeskHelpService.prefill({ name: user.full_name || '', email: user.email || '' });
    }),
});
